module.exports = __webpack_public_path__ + "img/fz_waterscan.4aa60d7a.png";